import { Box, FormControlLabel, StandardTextFieldProps, Switch } from '@material-ui/core'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { ChangeEventHandler, FC, ReactNode, useEffect, useState } from 'react'
//@ts-ignore
import styled, { useTheme } from 'styled-components'
import { RequiredSign, TextInput } from '../../atoms'
import { StyledInputContainer, StyledLabel } from '../../atoms/styled'

interface IInputProps extends StandardTextFieldProps {
  label?: string | ReactNode
  placeholder?: string
  name?: string
  required?: boolean
  displaySwitch?: boolean
  switchChangeHandler?: ChangeEventHandler
  type?: string
  area?: boolean
  rowSize?: number
  cols?: number
  areaValue?: any
  wordCount?: number
  showCounter?: boolean
  switchName?: string
  switchValue?: boolean
  titleWordCount?: number
  descriptionWordCount?: number
  handler?: ChangeEventHandler
  charLimit?: number
  areaDisabled?: boolean
  width?: string
  withHelperText?: boolean
}

const StyledSubscript = styled.sub<{ maxed: boolean }>`
  color: ${props => (props.maxed ? 'red' : props.theme.colors.accent1)};
  font-size: 0.75rem;
`

export const InputField: FC<IInputProps> = props => {
  const {
    width,
    label,
    placeholder,
    name,
    required,
    rowSize,
    area,
    wordCount,
    handler,
    switchChangeHandler,
    areaValue,
    switchName,
    showCounter = false,
    type = 'text',
    displaySwitch = false,
    titleWordCount,
    descriptionWordCount,
    charLimit = 10000,
    areaDisabled,
    switchValue,
    withHelperText,
    ...rest
  } = props
  const theme = useTheme()
  const { isDevice } = useScreenSizes()
  const [switchState, setSwitchState] = useState<boolean>(false)

  useEffect(() => {
    setSwitchState(switchValue)
  }, [switchValue])

  return (
    <StyledInputContainer>
      {label && (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <StyledLabel isDevice={true}>
            {label}
            <RequiredSign visible={required} />
          </StyledLabel>

          {displaySwitch && (
            <FormControlLabel
              control={
                <Switch
                  size="small"
                  color="primary"
                  checked={switchState}
                  defaultChecked={switchState}
                  name={switchName}
                  //@ts-ignore
                  onClick={switchChangeHandler}
                />
              }
              label="show"
              style={{ margin: 0 }}
            />
          )}
        </Box>
      )}
      {area ? (
        <>
          <TextInput
            placeholder={placeholder}
            multiline
            rows={5}
            value={areaValue}
            inputProps={{
              maxLength: charLimit
            }}
            name={name}
            onChange={handler}
            disabled={areaDisabled}
            {...rest}
          />
          <Box display="flex" flexDirection="column" justifyContent="flex-end" alignItems="flex-end">
            <StyledSubscript maxed={descriptionWordCount >= charLimit ? true : false}>
              {descriptionWordCount ?? 0}/{charLimit}
            </StyledSubscript>
          </Box>
        </>
      ) : (
        <>
          <TextInput type={type} placeholder={placeholder} name={name} required={required} {...rest} />
          {showCounter && <Box
            display="flex"
            marginTop={withHelperText ? '-1.5em' : 'unset'}
            flexDirection="column"
            justifyContent="flex-end"
            alignItems="flex-end"
          >
              <StyledSubscript maxed={titleWordCount >= charLimit ? true : false}>
                {titleWordCount ?? 0}/{charLimit}
              </StyledSubscript>
          </Box>}
        </>
      )}
    </StyledInputContainer>
  )
}
